import React from 'react';
import classnames from 'classnames';
import Icon, { EditOutlined, CopyOutlined } from '@ant-design/icons';
import moment from 'moment';
import { Popconfirm, Tooltip } from 'antd';
import { ReactComponent as TrashOutlinedIcon } from '../../../../../assets/icons/deleteIcon/trash-bin-red.svg';
import i18n from '../../../../../i18n';
import { copyToClipboard } from '../../../../../helpers/functions';
import { Trans } from 'react-i18next';
import styles from './ChatNote.module.scss';
const ChatNote = (props) => {
    const { text, createdAt, agentTitle, avatar, handleDeleteNote, hasPermission, onClick, highlighted, _id, handleEditNote, isEditing } = props;
    const renderActions = () => {
        if (!hasPermission)
            return null;
        return (React.createElement("div", { className: styles.chatNoteActions, onClick: (e) => e.stopPropagation() },
            React.createElement(Tooltip, { title: React.createElement(Trans, { i18nKey: "copyToClipboard" }) },
                React.createElement(Icon, { component: CopyOutlined, onClick: () => copyToClipboard(text), className: styles.copyIcon })),
            React.createElement(Icon, { component: EditOutlined, onClick: handleEditNote }),
            React.createElement(Popconfirm, { placement: "left", title: i18n.t('deleteChatNote'), icon: React.createElement(Icon, { component: TrashOutlinedIcon }), okButtonProps: {
                    type: 'primary',
                    danger: true,
                }, okText: i18n.t('deleteConfirm'), cancelText: i18n.t('cancel'), onConfirm: handleDeleteNote, onCancel: (e) => e === null || e === void 0 ? void 0 : e.stopPropagation() },
                React.createElement(Icon, { component: TrashOutlinedIcon, onClick: (e) => e.stopPropagation() }))));
    };
    return (React.createElement("div", { id: `chat-note-${_id}`, className: classnames(styles.singleChatNote, {
            [styles.highlighted]: highlighted || isEditing,
        }), onClick: onClick },
        React.createElement("img", { src: avatar, className: styles.chatNoteAvatar, alt: "Agent avatar" }),
        React.createElement("div", { className: styles.rightColumn },
            React.createElement("div", { className: styles.topRow },
                React.createElement("div", { className: styles.chatNoteName }, agentTitle),
                renderActions()),
            React.createElement("div", { className: styles.chatNoteText }, text),
            React.createElement("div", { className: styles.chatNoteDate }, moment(createdAt).format('hh:mm A, MMMM Do YYYY')))));
};
export default ChatNote;
